module.exports = __webpack_public_path__ + "joy-static/media/HealthIcon.fbe1ff56.png";